<template>
    <div>
        <div class="text-grey-darkest bg-white shadow-md rounded  mt-12 ml-20 border-1">
            <div class="card m-0">
                <div class="card-header">
                    <p class="inline-block font-weight-bolder" style="margin-left: 10px">Change Order Settings</p>
                    <span class="pull-right">
                        <label for="customButtonSwitch" class="inline-block">OFF</label>
                        <b-form-checkbox @change="changeOrderSwitchUpdate" name="check-button" v-model="changeOrderCheck" id="customButtonSwitch" class="inline-block" style="margin-left:10px !important" switch>
                        </b-form-checkbox>
                        <label for="customButtonSwitch" class="inline-block">ON</label>
                        </span>
                </div>
                <div class="card-body">
                    <form>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="SumToContractAmount" name="SumToContractAmount" v-model="form.SumToContractAmount" @click="changeOrderCheckboxes('SumToContractAmount', $event)">
                            <label class="form-check-label font-weight-bolder" for="SumToContractAmount">
                                Sum to the Contract Amount
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="SumToPreviousYearsReporting" name="SumToPreviousYearsReporting" v-model="form.SumToPreviousYearsReporting" @click="changeOrderCheckboxes('SumToPreviousYearsReporting', $event)">
                            <label class="form-check-label font-weight-bolder" for="SumToPreviousYearsReporting">
                                Sum to the Previous Years Reporting
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddToPipelineGraph" name="AddToPipelineGraph" v-model="form.AddToPipelineGraph" @click="changeOrderCheckboxes('AddToPipelineGraph', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddToPipelineGraph">
                                Add to Pipeline Graph
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddToClosingRatio" name="AddToClosingRatio" v-model="form.AddToClosingRatio" @click="changeOrderCheckboxes('AddToClosingRatio', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddToClosingRatio">
                                Add to Closing Ratio Chart
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddToContract" name="AddToContract" v-model="form.AddToContract" @click="changeOrderCheckboxes('AddToContract', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddToContract">
                                Add to Contract Chart
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddToBidVolume" name="AddToBidVolume" v-model="form.AddToBidVolume" @click="changeOrderCheckboxes('AddToBidVolume', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddToBidVolume">
                                Add to Bid Volume Chart
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddToGrossMargin" name="AddToGrossMargin" v-model="form.AddToGrossMargin" @click="changeOrderCheckboxes('AddToGrossMargin', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddToGrossMargin">
                                Add to Gross Margin Chart
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddToWonContractReport" name="AddToWonContractReport" v-model="form.AddToWonContractReport" @click="changeOrderCheckboxes('AddToWonContractReport', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddToWonContractReport">
                                Add to Won Contracts Report
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AddChangeOrderWithOutProject" name="AddChangeOrderWithOutProject" v-model="form.AddChangeOrderWithOutProject" @click="changeOrderCheckboxes('AddChangeOrderWithOutProject', $event)">
                            <label class="form-check-label font-weight-bolder" for="AddChangeOrderWithOutProject">
                                Add to Won Contracts Report when in Contract status (even if the project sales status is not in Contract status)
                            </label>
                        </div>
                    </form>

                </div>

            </div>
        </div>

        <div class="text-grey-darkest bg-white shadow-md rounded  mt-12 ml-20 border-1 py-4" style="color: #01b1af;">
            <change-order-custom-fields :team="team" :key="refresh"></change-order-custom-fields>
        </div>
    </div>
</template>

<script>

import Form from "../../../utils/form";

export default {
    name: 'change-order',
    props: {
        team:{},
        user:{}
    },
    data() {
        return {
            'changeOrderCheck':(this.team.project_change_orders === 1) ? true :false,
            form: new Form({
                SumToContractAmount: (this.team.has_sum_contract_amount === 1) ? true : false,
                SumToPreviousYearsReporting: (this.team.has_sum_previous_years_reporting === 1) ? true : false,
                AddToPipelineGraph: (this.team.has_pipeline_graph === 1) ? true : false,
                AddToClosingRatio: (this.team.has_closing_ratio_graph === 1) ? true : false,
                AddToContract: (this.team.has_contract_chart_graph === 1) ? true : false,
                AddToBidVolume: (this.team.has_bid_volume_graph === 1) ? true : false,
                AddToGrossMargin: (this.team.has_gross_margin_graph === 1) ? true : false,
                AddToWonContractReport: (this.team.has_won_contract_report === 1) ? true : false,
                AddChangeOrderWithOutProject: (this.team.has_change_order_to_won_contract === 1) ? true : false,
            }),
            refresh: 1
        };
    },
    created() {

    },
    methods: {
        changeOrderSwitchUpdate(){
            this.$nextTick(()=>{
                var data = {
                    'access': (this.changeOrderCheck)? 1:0
                };
                axios.post(route('change_order.check'), data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        })
                    }
                );
            });
        },

        changeOrderCheckboxes(checkboxName, event)
        {
            let value = event.target.checked;

            if(value === true) {
                value = 1;
            } else if(value === false) {
                value = 0;
            }

            if(checkboxName === 'SumToPreviousYearsReporting') {
                if(!($('#SumToContractAmount').is(":checked"))) {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please Check Sum of the Contract Amount First!'
                    });
                    return false;
                }
            }
            //
            // if(checkboxName === 'AddToClosingRatio' || checkboxName === 'AddToContract') {
            //     if(!($('#SumToContractAmount').is(":checked"))) {
            //         this.getToast().fire({
            //             type: 'error',
            //             title: 'Please Check Sum of the Contract Amount First!'
            //         });
            //         return false;
            //     }
            // }

            let data = {
                value: value,
                checkbox_name: checkboxName,
            };

            axios.post(route('change_order.checkboxes'), data).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }
            );
        }

    },


}
</script>

